import { Injectable } from '@angular/core';
import { ConfigurationService } from '../shared/configuration.service';
import { Headers, Http, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class UserService {
  private baseUrl = "";
  constructor(

    private http: Http,
    private _configuration: ConfigurationService

  ) {

    this.baseUrl = _configuration.baseUrl;
  }

  // Register(email: string, password: string) {

  //     let postData = { email: email, password: password, confirmPassword: confirmPassword } as any;
  //     let url = this._configuration.baseUrl+ '/api/account/register';
  //     this.http
  //         .post(url, postData).toPromise()
  //         .then(registration => {
  //             alert('created Account')
  //         })
  //         .catch(this.handleError);


  // }
  private requestOptions(): RequestOptions {
    let headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return options;
  }


  // Observable string sources
  private emitHeaderTypeSource = new Subject<string>();
  // Observable string streams
  headerTypeEmitted$ = this.emitHeaderTypeSource.asObservable();
  // Service message commands
  emitUpdateHeaderType(headerType: string) {
    this.emitHeaderTypeSource.next(headerType);
  }

  public CleanUrlAfterSignin() {

    if (window.location.hash == '#_=_') {
      history.replaceState ? history.replaceState(null, null, window.location.href.split('#')[0]) : window.location.hash = '';
    }
  }
  LogOut(): Observable<string> {
    //let postData =  {email:email, password:password }as any;

    return this.http.get(this._configuration.baseUrl + '/api/account/logout', this.requestOptions())
      .map(response => { return response; })
      .catch(this.handleError);

  }



  Register(body: any): Observable<string> {
    //let postData =  {email:email, password:password }as any;

    return this.http.post(this._configuration.baseUrl + '/api/account/register', body, this.requestOptions())
      .map(response => { return response; })
      .catch(this.handleError);

  }


  CreateRegister(body: any): Promise<any> {
    let headers = new Headers({ 'Content-Type': 'application/json' });

    let options = new RequestOptions({ headers: headers, withCredentials: true });
    let url = this._configuration.baseUrl + '/api/registries';
    return this.http
      .post(url, body, options).toPromise()
      .then(registration => {

        return body.RegistryName;
      })
      .catch(this.handleError);


  }

  LinkWithFacebook() {

    let headers = new Headers({ 'Content-Type': 'application/json' });

    let options = new RequestOptions({ headers: headers, withCredentials: true });
    let postData = { provider: 'facebook', returnUrl: 'http://localhost:4200/continueRegistration' } as any;

    return this.http.post(this._configuration.baseUrl + '/api/Account/ExternalLogin', JSON.stringify(postData), options)
      .map((res) => {


      })
      .catch(this.handleError);

  }

  GetHeader() {
    let headers = new Headers({ 'Content-Type': 'application/json' });

    let options = new RequestOptions({ headers: headers, withCredentials: true });


    return this.http.get(this._configuration.baseUrl + '/api/account/isloggedin', options)

      .map((res) => {


        return res;
      })
      .catch(this.handleAuthException);

  }

  getMyEmail(): Observable<string> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return this.http.get(this._configuration.baseUrl + '/api/account/me', options)
      .map((res: any) => {
        //            this._cacheService.set('user-getmyEmail', res._body, { expires: Date.now() + 1000 * 60 * 45 });
        return res._body;
      })
      .catch((e) => this.redirectToLogin(e, this._configuration.baseUrl));

  }

  IsLoggedIn(): Observable<boolean> {
    //
    return Observable.of(true);
    // let headers = new Headers({ 'Content-Type': 'application/json' });
    // let options = new RequestOptions({ headers: headers, withCredentials: true });
    // return this.http.get(this._configuration.baseUrl + '/api/account/isloggedin', options)
    //     .map((res: any) => {
    //        return res;
    //     })
    //     .catch((e)=>this.handleAuthException(e));

  }

  private redirectToLogin(error: any, baseUrl: string): Promise<any> {

    if (error.status == 401 || error.status == 500) {

      location.href = baseUrl + "/login";

    }
    return Promise.resolve(false);
  }


  private handleAuthException(error: any): Promise<any> {


    if (error.status == 401) {


      return Promise.resolve(false);
    }
    else {
      return Promise.reject(error.message.body || error);
    }
  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message.body || error);
  }
}





// WEBPACK FOOTER //
// ./src/app/user/user.service.ts